export default function PID({ children }: { children: string }) {
  return (
    <code className="rounded-sm border border-gray-light px-px text-xs text-gray-dark">
      {children}
    </code>
  );
}
